// Must match app/services/paywalls/payment_methods.rb

export const paymentMethodTypes = {
  affirm: "affirm",
  afterpay_clearpay: "afterpay_clearpay",
  apple_pay: "apple_pay",
  bancontact: "bancontact",
  card: "card",
  google_pay: "google_pay",
  ideal: "ideal",
  klarna: "klarna",
  link: "link",
  pix: "pix",
  sepa_debit: "sepa_debit",
  revenue_cat_app_store: "revenue_cat_app_store",
  revenue_cat_play_store: "revenue_cat_play_store",
} as const;
export type PaymentMethodType = keyof typeof paymentMethodTypes;

export const cardBrands = {
  amex: "amex",
  diners: "diners",
  discover: "discover",
  jcb: "jcb",
  mastercard: "mastercard",
  unionpay: "unionpay",
  visa: "visa",
  generic: "generic",
} as const;
export type CardBrand = keyof typeof cardBrands;
